import React from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../components/FormGroup/FormGroup';
import FormItem from '../../components/FormItem/FormItem';
import IconButton from '../../components/IconButton/IconButton';
import Input from '../../components/Input/Input';
import Panel from '../../components/Panel/Panel';
import PanelHeader from '../../components/PanelHeader/PanelHeader';

import Check24 from '../../icons/Check24';
import Close24 from '../../icons/Close24';

import useApi from '../../utils/api';
import { useAuth } from '../../utils/auth';
import {
    validateEmail,
    validateName,
    validatePhone
} from '../../utils/validate';

export default function EditClient(props) {
    const { onBackClick, data, panelWidth, onUpdated } = props;

    const api = useApi();
    const auth = useAuth();

    const [loading, setLoading] = React.useState(false);

    const [name, setName] = React.useState({
        value: data.name,
        error: null,
    });
    const [email, setEmail] = React.useState({
        value: data.email,
        error: null,
    });
    const [phone, setPhone] = React.useState({
        value: data.phone_number,
        error: null,
    });

    function handleNameChange(e) {
        const value = e.target.value;
        const error = validateName(value);
        setName((name) => ({ ...name, value, error }));
    }

    function handleEmailChange(e) {
        const value = e.target.value;
        const error = validateEmail(value);
        setEmail({ value, error });
    }

    function handlePhoneChange(e) {
        const value = e.target.value;
        const error = validatePhone(value);
        setPhone({ value, error });
    }

    function isValid() {
        return !name.error && !email.error && !phone.error;
    }

    function prepareSettings() {
        return {
            name: name.value,
            email: email.value,
            phone_number: phone.value,
        };
    }

    function handleSaveClick() {
        if (!isValid()) return;

        setLoading(true);

        const settings = prepareSettings();
        const companyId = auth?.company?.id;
        const clientId = data.id;

        api.updateClient(companyId, clientId, settings)
            .then(result => {
                if (result) {
                    if (typeof onUpdated === 'function') {
                        onUpdated(result);
                    }
                } else {
                    alert('Не удалось обновить информацию');
                }
            })
            .catch(error => {
                console.error(error);
                alert('Не удалось обновить информацию.');
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Panel
            noShrink={true}
            contentStyles={{ minWidth: panelWidth, padding: '0 0.5rem' }}
            separated={true}
            header={
                <PanelHeader
                    back={true}
                    backIcon={<Close24 />}
                    onBackClick={onBackClick}
                    title={'Редактировать'}
                    after={
                        <IconButton
                            icon={<Check24 />}
                            onClick={handleSaveClick}
                            loading={loading}
                            accent={true}
                        />
                    }
                />
            }
        >
            <FormGroup title={'Общая информация'}>
                <FormItem label={'Имя'} required={true} error={name.error}>
                    <Input
                        name="name"
                        type="text"
                        placeholder={'Имя клиента'}
                        onChange={handleNameChange}
                        value={name.value}
                    />
                </FormItem>
                <FormItem label={'Email'} required={true} error={email.error}>
                    <Input
                        name="email"
                        type="text"
                        placeholder={'Электронная почта'}
                        onChange={handleEmailChange}
                        value={email.value}
                    />
                </FormItem>
                <FormItem label={'Телефон'} required={true} error={phone.error}>
                    <Input
                        name="phone_number"
                        type="text"
                        placeholder={'Электронная почта'}
                        onChange={handlePhoneChange}
                        value={phone.value}
                    />
                </FormItem>
            </FormGroup>
        </Panel>
    );
}

EditClient.propTypes = {
    onBackClick: PropTypes.func,
    data: PropTypes.object,
    panelWidth: PropTypes.number,
    onUpdated: PropTypes.func,
};
